import * as React from 'react';
import { Form, Header, Popup, Segment } from 'semantic-ui-react';

import listaComponentes from 'src/modulos/Matriculas/IngresoNuevaMatricula/componentes/ListaComponentes';
import Alumno, { Datos as AlumnoDatos, inicial as alumnoInicial } from './componentes/Alumno';

export interface Datos {
    alumnoPrincipal: AlumnoDatos;
    otrosAlumnos: AlumnoDatos[];
}

export const inicial: Datos = {
    alumnoPrincipal: { ...alumnoInicial },
    otrosAlumnos: [],
};

const ListaAlumnos = listaComponentes<AlumnoDatos, {}>(props => {
    const { item, onChange, onDelete } = props;
    return <Alumno mostrarBotonEliminar alumno={item} onChange={onChange} onDelete={onDelete} />;
});

interface Props {
    alumnoPropioApoderado: boolean;
    alumnos: Datos;
    onChange(alumnos: Datos): void;
}

class Alumnos extends React.PureComponent<Props> {
    public render() {
        const { alumnoPropioApoderado, alumnos } = this.props;

        return (
            <Segment>
                <Header as='h2'>Alumnos</Header>
                <Alumno
                    alumnoPropioApoderado={alumnoPropioApoderado}
                    alumno={alumnos.alumnoPrincipal}
                    onChange={this.manejarCambioAlumnoPrincipal}
                />

                <ListaAlumnos
                    array={alumnos.otrosAlumnos}
                    onChange={this.manejarCambioOtrosAlumnos}
                />

                <Popup
                    trigger={
                        <Form.Button
                            type='button'
                            color='green'
                            icon='plus'
                            content='Agrega otro alumno'
                            onClick={this.agregarAlumno}
                        />
                    }
                    content='Agrega otro alumno al mismo apoderado.'
                />
            </Segment>
        );
    }

    private readonly agregarAlumno = () => {
        const { alumnos, onChange } = this.props;
        const otro = { ...alumnoInicial };
        const otrosAlumnos = [...alumnos.otrosAlumnos, otro];
        onChange({ ...alumnos, otrosAlumnos });
    };

    private readonly manejarCambioAlumnoPrincipal = (alumnoPrincipal: AlumnoDatos) => {
        const { alumnos, onChange } = this.props;

        onChange({ ...alumnos, alumnoPrincipal });
    };

    private readonly manejarCambioOtrosAlumnos = (otrosAlumnos: AlumnoDatos[]) => {
        const { alumnos, onChange } = this.props;

        onChange({ ...alumnos, otrosAlumnos });
    };
}

export default Alumnos;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S3Alumnos/index.tsx